<template>
  <div>
    <v-container fluid pa-0>
      <v-layout row wrap justify-space-between class="datSectionTitleBg px-4 py-5">
        <v-flex xs12 sm6 class="datSectionTitle">
          {{ $t('administracionUsuarios') }}
        </v-flex>
        <v-flex shrink>
          <v-btn v-if="dIsOnPremise" class="datPrimaryBtn" flat @click="dOpenModal = true">{{ $t('nuevoUsuario')
          }}</v-btn>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-btn flat class="datPrimaryBtn" @click="dOpenModalAlmacenes = true">{{ this.$t("confAlmacenes") }}</v-btn>
          <v-btn flat class="datPrimaryBtn" @click="dOpenModalRoles = true">{{ this.$t("tiposUsersText") }}</v-btn>
        </v-flex>
      </v-layout>

    </v-container>
    <v-container fluid grid-list-xl mb-5 pa-0>
      <v-layout row wrap class="px-4 contentBg">
        <v-card class="overlapping cardHeight pa-0" width="100%">
          <v-card-text class="pa-0">
            <v-layout row wrap>
              <v-flex xs12 md6 mb-2>
                <!-- tabla visualización datos -->
                <ShpAdministracionRoles :dOpenAdminRoles="dOpenModalRoles" @close="dOpenModalRoles = false">
                </ShpAdministracionRoles>
                <ShpAdministracionAlmacenes :dOpenAdminAlmacenes="dOpenModalAlmacenes"
                  @close="dOpenModalAlmacenes = false">
                </ShpAdministracionAlmacenes>
                <ShpAdministracionNuevoUsuario v-if="dIsOnPremise" :dOpenModal="dOpenModal" @close="dOpenModal = false">
                </ShpAdministracionNuevoUsuario>
                <DataTableNuevo ref="DataTableUser" id="tableUser" class="data-lis data-tableMisClientes"
                  :dataTableId="dataTableId" :headers="headers" :items="items" :getDataApi="dEventosBus.cargaLista"
                  :clickedApi="dEventosBus.muestraDatos" :totalItems="totalItems" :rowsPerPage="pagination.rowsPerPage"
                  :initSearch="cSearch" :sortBy="sortBy" :descending="descending" :loading="loading"
                  :checkboxOn="false">
                  <template slot="filter">
                    <v-select dark v-model="dEstadoFiltro" :items="itemsEstadoFiltro" :label="$t('estado')"
                      item-text="text" item-value="value" hide-details flat
                      :menu-props="{ contentClass: 'menu-filtro-estado', light: true }"
                      class="pl-2 estado-filter-select" @change="fCambiarEstadoFiltro"></v-select>
                  </template>
                </DataTableNuevo>
              </v-flex>
              <v-flex xs12 md6>
                <!-- header tabs -->
                <v-flex class="subsectionTabs pa-0">
                  <v-tabs id="tabs" v-model="dTab" grow>
                    <v-tab>
                      {{ $t('datos') }}
                    </v-tab>
                    <v-tab>
                      {{ $t('asociacion') }}
                    </v-tab>
                    <v-tab>
                      {{ $t('accesosUsuario') }}
                    </v-tab>
                    <v-tab>
                      {{ $t('informes') }}
                    </v-tab>
                  </v-tabs>
                  <!-- header tabs -->
                </v-flex>
                <v-tabs-items v-model="dTab" :height="dHeight">
                  <!-- tab 1 -->
                  <v-tab-item>
                    <v-flex>
                      <v-layout row wrap align-center>
                        <v-flex xs12 sm10>
                          <v-flex xs12>
                            <v-text-field id="loginUser" :value="dUsuarioSeleccionado.usuario" :label="$t('usuario')"
                              disabled hide-details></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field id="nameUser" :value="dUsuarioSeleccionado.nombre" :label="$t('nombre')"
                              disabled hide-details></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field id="emailUser" :value="dUsuarioSeleccionado.email" :label="$t('email')"
                              disabled hide-details></v-text-field>
                          </v-flex>
                          <v-flex xs12>
                            <v-text-field id="phoneUser" :value="dUsuarioSeleccionado.telefono" :label="$t('telefono')"
                              disabled hide-details></v-text-field>
                          </v-flex>
                        </v-flex>
                        <v-flex hidden-xs-only shrink class="mx-auto">
                          <v-icon class="tabIcon">mdi-face</v-icon>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-tab-item>
                  <!-- tab 2 -->
                  <v-tab-item>
                    <v-flex>
                      <v-layout row wrap align-center>
                        <v-flex xs12 sm10>
                          <v-flex xs12>
                            <v-autocomplete color="datPrimary" id="changeEmpresa" v-bind:items="itemsEmpresas"
                              :label="$t('empresa')" :item-text="fText" item-value="empresa" v-model="selectEmpresa"
                              hide-details>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 v-show="selectEmpresa !== '' && dTab === 1">
                            <v-autocomplete color="datPrimary" id="tipeUser" v-bind:items="itemsRoles"
                              :label="this.$t('tipoUsuario')" item-text="descripcionTexto" item-value="role"
                              v-model="selectRole" hide-details>
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12
                            v-if="(selectRole === 'CLIENTE' || selectRole === 'SUCURSAL' || selectRole === 'MULTISUCURSAL') && dTab === 1">
                            <DatTextFieldCode ref="RefTablaClient" :pDataPass="dDataClient" @select="fSelectClient"
                              @clean="fCleanClient"></DatTextFieldCode>
                            <template v-if="selectRole === 'SUCURSAL' && dTab === 1">
                              <DatTextFieldCode v-show="!dIsOnPremise" ref="RefTablaSucursal" :pDataPass="dDataSucursal"
                                @select="fSelectSucursal" @clean="fClearSucursal"></DatTextFieldCode>
                            </template>
                            <template
                              v-if="selectRole === 'MULTISUCURSAL' && dTab === 1 && dSelectClient.codigo !== '' && dSelectClient.codigo !== undefined">
                              <v-layout row>
                                <v-flex xs3>
                                  <v-text-field append-icon="mdi-magnify" hide-details v-model="searchSUC"
                                    label="Buscar Sucursales"></v-text-field>
                                </v-flex>
                              </v-layout>
                              <v-layout>
                                <v-flex>
                                  <v-card>
                                    <v-data-table height="inherit" :headers="headersSUC" :items="sucursales"
                                      :no-data-text="this.$t('noResultados')" :no-results-text="this.$t('noResultados')"
                                      v-bind:pagination.sync="paginationSUC" :loading="loadingSUC"
                                      :total-items="totalItemsSUC" :rows-per-page-items="rowsPerPageArraySUC" sm12
                                      class="mt-1 mb-4" select-all v-model="selectedSUC">
                                      <template slot="headers" slot-scope="props">
                                        <tr class="data-gbGreyLight">
                                          <th id="selectAll">
                                            <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate"
                                              hide-details @change="toggleAll"
                                              v-model="dSelectAllElements"></v-checkbox>
                                          </th>
                                          <th class="text-xs-left " v-for="header in props.headers" :key="header.text"
                                            :id="header.value"
                                            :class="['column sortable', paginationSUC.descending ? 'desc' : 'asc', header.value === paginationSUC.sortBy ? 'active' : header.class, 'text-xs-' + header.align + ' ' + header.class + ' ']"
                                            @click="cambiaOrden(header.value)">
                                            <v-icon v-if="header.sortable">arrow_upward</v-icon>
                                            {{ header.text }}
                                          </th>
                                        </tr>
                                      </template>
                                      <template slot="items" slot-scope="props">
                                        <tr :active="props.selected">
                                          <td>
                                            <v-checkbox :input-value="props.selected" color="datSecondary" hide-details
                                              @change="fChangeSelectedItem(props)"></v-checkbox>
                                          </td>
                                          <td class="text-xs-left">{{ props.item.sucursal }}</td>
                                          <td class="text-xs-left">{{ props.item.razonSocial }}</td>
                                        </tr>
                                      </template>
                                    </v-data-table>
                                  </v-card>
                                </v-flex>
                                <v-flex>
                                  <v-card>
                                    <ul>
                                      <li v-for="item in selectedSUC" :key="item.id">
                                        {{ item.sucursal }} - {{ item.razonSocial }}
                                      </li>
                                    </ul>
                                  </v-card>
                                </v-flex>
                              </v-layout>

                            </template>
                          </v-flex>
                          <v-flex xs12 v-else-if="selectRole === 'REPRESENTANTE' && dTab === 1">
                            <DatTextFieldCodeSubfield ref="RefTablaRepre" :pDataPass="dDataRepre" @select="fSelectRepre"
                              @clean="fCleanRepre">
                            </DatTextFieldCodeSubfield>

                          </v-flex>

                        </v-flex>
                        <v-flex hidden-xs-only shrink class="mx-auto">
                          <v-icon class="tabIcon">mdi-share-variant</v-icon>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 text-xs-left>
                      <v-btn class="datPrimaryBtn" id="deleteUser" flat @click="fEliminarUsuario">{{ $t('borrar')
                      }}</v-btn>
                    </v-flex>
                  </v-tab-item>
                  <!-- tab 3 -->
                  <v-tab-item>
                    <v-flex>
                      <v-layout row wrap align-center>
                        <v-flex xs12 sm10>
                          <v-flex xs12 v-for="(opcion, index) in itemsOpciones" v-bind:key="index">
                            <v-checkbox class="mt-0" :id="'opcion_' + opcion.value" color="datSecondary"
                              :label="opcion.nombreTxt" v-model="opcion.value" @change="changeValue(index)"
                              hide-details></v-checkbox>
                          </v-flex>
                        </v-flex>
                        <v-flex hidden-xs-only shrink class="mx-auto">
                          <v-icon class="tabIcon">mdi-minus-box-outline</v-icon>
                        </v-flex>

                      </v-layout>
                    </v-flex>
                  </v-tab-item>
                  <!-- tab 4 -->
                  <v-tab-item>
                    <v-flex>
                      <v-layout row wrap align-center>
                        <v-flex xs12 sm10>
                          <v-list class="scrollable">
                            <v-list-tile v-for="(item, i) in flatInformes" :key="i" style="height: auto">
                              <v-list-tile-content v-if="item.type === 'main'">
                                <v-checkbox color="datSecondary" :id="'informe_' + item.informe.informe"
                                  :label="item.informe.descripcionTxt" v-model="item.informe.value"
                                  @change="changeValue(item.originalIndex)">
                                </v-checkbox>
                              </v-list-tile-content>
                              <v-list-tile-content v-else class="pl-4">
                                <v-layout row align-center>
                                  <span class="pr-2 hierarchy-marker">└─</span>
                                  <v-checkbox color="datSecondary" :id="item.fieldName"
                                    :label="$t(item.labelKey)"
                                    v-model="dUsuarioSeleccionado[item.fieldName]"
                                    :disabled="!item.informe.value">
                                  </v-checkbox>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-list>

                        </v-flex>
                        <v-flex hidden-xs-only shrink class="mx-auto">
                          <v-icon class="tabIcon">mdi-file-document-outline</v-icon>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-tab-item>
                </v-tabs-items>
                <v-flex xs12 text-xs-right>
                  <v-btn class="datPrimaryBtn" id="updateUser" flat @click="actualizaUsuario()">{{ $t('aceptar')
                  }}</v-btn>
                </v-flex>

              </v-flex>
            </v-layout>

          </v-card-text>
        </v-card>

      </v-layout>
    </v-container>

    <!-- comprobacion borrado -->
    <v-dialog v-model="alertaGuardadoPendiente" persistent max-width="370">
      <v-card class="data-aviso">
        <v-card-title class="subheading">{{ this.$t('guardadoDatosPendiente') }}</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="datPrimaryBtnOut" @click="cierraAlertaGuardadoPendiente()">{{ this.$t('no') }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="datPrimaryBtn" @click="cierraAlertaGuardando()">{{ this.$t('si') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

import DataTableNuevo from '@/components_datadec/DataTableNuevo'
import DatTextFieldCode from '@/components_datadec/DatTextFieldCode'
import DatTextFieldCodeSubfield from '@/components_datadec/DatTextFieldCodeSubfield'
import ShpAdministracionNuevoUsuario from '@/components/Administracion/ShpAdministracionNuevoUsuario'
import ShpAdministracionRoles from '@/components/Administracion/ShpAdministracionRoles'
import ShpAdministracionAlmacenes from '@/components/Administracion/ShpAdministracionAlmacenes'
import SrvAdmUsuarios from '@/services/srv-adm-usuarios.js'
import SrvFechasRoles from '@/services/srv-fechas-roles'
import SrvGeneral from '@/services/srv-general'
import SrvUsers from '@/services/srv-users'

export default {
  name: 'ShpAdministracionUsuarios',
  components: {
    DataTableNuevo,
    DatTextFieldCode,
    DatTextFieldCodeSubfield,
    ShpAdministracionNuevoUsuario,
    ShpAdministracionRoles,
    ShpAdministracionAlmacenes
  },
  data() {
    return {
      dHeight: 'calc(100vh - 300px)',
      cargandoUsuario: false,
      puedeActivarUsuario: false,
      alertaGuardadoPendiente: false,
      usuarioPendiente: null,
      disabledUpdate: true,
      changes: false,
      dSearch: '',
      dRoleSelect: '',
      dTab: 0,
      dEventosBus: {
        'cargaLista': 'evento-cargaListaUsuarios',
        'muestraDatos': 'evento-muestraDatosUsuario',
        'dSelectClient': 'evento-seleccionaClienteAdmUsuarios',
        'seleccionaRepresentante': 'evento-seleccionaRepresentanteAdmUsuarios',
        'mostrarAviso': 'evento-mostrarAvisos'
      },
      dDataSucursal: {},
      dataTableId: 'USUARIOS',
      dUsuarioSeleccionado: { usuario: '', nombre: '', email: '', telefono: '', empresa: '', role: '', cliente: '', representante: '', agente: '', opciones: [], informes: [] },
      usuarioSeleccionadoIni: { usuario: '', nombre: '', email: '', telefono: '', empresa: '', role: '', cliente: '', representante: '', agente: '', opciones: [], informes: [] },
      itemsRoles: [],
      totalItems: 0,
      pagination: {
        rowsPerPage: 5
      },
      activo: false,
      sortBy: 'usuario',
      descending: false,
      search: '',
      loading: true,
      headers: [
        { text: this.$t('usuario'), align: 'left', value: 'usuario', column: 'usuario' },
        { text: this.$t('nombre'), align: 'left', value: 'nombre', column: 'nombre' },
        { text: this.$t('email'), align: 'left', value: 'email', column: 'email' }
      ],
      items: [],
      itemsEmpresas: [],
      itemsOpciones: [],
      itemsInformes: [],
      selectEmpresa: '',
      selectRole: '',
      dSelectClient: { codigo: '', nombre: '' },
      dSelectSucursal: { codigo: '', nombre: '' },
      dRequestClient: { empresa: this.selectEmpresa },
      dSelectRepre: { codigo: '', subfield: '', nombre: '' },
      dDataClient: {},
      dDataRepre: {},
      dRequestRepre: { empresa: this.selectEmpresa },
      ultimosParametros: {},
      dMostrarNuevosUsuarios: false,
      dOpenModal: false,
      dIsOnPremise: localStorage.getItem('isOnPremise') === 'yes',
      dOpenModalRoles: false,
      dOpenModalAlmacenes: false,
      paginationSUC: { 'sortBy': 'sucursal', 'descending': false, 'rowsPerPage': 8 },
      headersSUC: [
        {
          text: this.$t('sucursal'),
          align: 'left',
          value: 'sucursal',
          sortable: false
        },
        {
          text: this.$t('nombre'),
          align: 'left',
          value: 'razonSocial',
          sortable: false
        }
      ],
      sucursales: [],
      searchSUC: '',
      dTableHeadersSuc: [
        { text: 'Id', value: 'sucursal', align: 'right', sortable: false },
        { text: 'Nombre', value: 'razonSocial', align: 'left', sortable: false },
        //{ text: '', value: 'actions',sortable: false}
      ],
      dTableActionsSuc: [
        {
          id: 0,
          name: 'Asignar representante',
          icon: 'mdi-account-plus',
          btnclass: 'datPrimaryBtnIcon mx-1',
          class: '',
          exec: this.fAssignSucursal
        }
      ],
      loadingSUC: false,
      dSearchSucTime: 0,
      totalItemsSUC: 0,
      rowsPerPageArraySUC: [8],
      selectedSUC: [],
      dSucursales: [],
      dSelectAllElements: false,
      dEstadoFiltro: 'todos',
      itemsEstadoFiltro: []
    }
  },
  watch: {
    'searchSUC': {
      handler: function () {
        this.fSearchSucursal()
      },
      deep: true
    },
    'selectedSUC': {
      handler: function () {
        this.dSucursales = []
        for (var i = 0; i < this.selectedSUC.length; i++) {
          this.dSucursales.push(this.selectedSUC[i].sucursal)
        }
      },
      deep: true
    },
    'dSelectClient': {
      handler: function () {
        if (this.selectRole === 'MULTISUCURSAL' && this.dSelectClient.codigo !== undefined && this.dSelectClient.codigo !== '') {
          this.cargaSucursales(this.paginationSUC.sortBy, this.paginationSUC.descending, this.paginationSUC.page, this.paginationSUC.rowsPerPage, this.searchSUC, [])
        }
      },
      deep: true
    },
    'selectEmpresa': {
      handler: function () {
        this.dUsuarioSeleccionado.empresa = this.selectEmpresa
        this.dDataClient.request = { empresa: this.dUsuarioSeleccionado.empresa }
        this.dDataRepre.request = { empresa: this.dUsuarioSeleccionado.empresa }
        this.dDataSucursal.request = { empresa: this.dUsuarioSeleccionado.empresa }
        if (this.usuarioSeleccionadoIni.empresa !== this.dUsuarioSeleccionado.empresa) {
          this.selectRole = ''
          this.itemsOpciones = []
          this.itemsInformes = []
          this.dSelectClient = { codigo: '', nombre: '' }
          this.dSelectRepre = { codigo: '', subfield: '', nombre: '' }
        }
        this.checkChange()
      },
      deep: true
    },
    'dTab': {
      handler: function () {
        if (this.selectRole === 'REPRESENTANTE') {
          setTimeout(() => {
            if (this.$refs.RefTablaRepre) {
              this.$refs.RefTablaRepre.fActualizarItem({ 'codigo': this.dUsuarioSeleccionado.representante, 'subfield': this.dUsuarioSeleccionado.agente, 'nombre': this.dUsuarioSeleccionado.representanteNombre })
            }
          }, 200)
        } else if (this.selectRole === 'CLIENTE' || this.selectRole === 'MULTISUCURSAL') {
          setTimeout(() => {
            if (this.$refs.RefTablaClient) {
              this.$refs.RefTablaClient.fActualizarItem({ 'codigo': this.dUsuarioSeleccionado.cliente, 'nombre': this.dUsuarioSeleccionado.clienteNombre })
            }
          }, 200)
        } else if (this.selectRole === 'SUCURSAL') {
          setTimeout(() => {
            if (this.$refs.RefTablaClient !== undefined) {
              this.$refs.RefTablaClient.fActualizarItem({ 'codigo': this.dSelectClient.codigo, 'nombre': this.dSelectClient.nombre })
            }
            if (this.$refs.RefTablaSucursal !== undefined && this.dSelectClient.codigo !== '' && this.dSelectClient.codigo !== undefined) {
              this.$refs.RefTablaSucursal.fChangeDisabled(false)
              this.$refs.RefTablaSucursal.fActualizarItem({ 'codigo': this.dSelectSucursal.codigo, 'nombre': this.dSelectSucursal.nombre })
            }
          }, 200)
        }
      },
      deep: true
    },
    'selectRole': {
      handler: function () {
        this.dRoleSelect = this.selectRole
        if (this.usuarioSeleccionadoIni.role !== this.dRoleSelect) {
          if (this.dRoleSelect === "CLIENTE") {
            this.fCleanClient()
          }
          for (let i = 0; i < this.itemsRoles.length; i++) {
            const roleTemp = this.itemsRoles[i]

            if (roleTemp.role === 'ADMIN') {
              roleTemp.informes.forEach(informe => {
                informe.value = true
                informe.valueSN = 'S'
                return informe
              })
              roleTemp.opciones.forEach(opcion => {
                opcion.value = true
                opcion.valueSN = 'S'
                return opcion
              })
            } else if (roleTemp.role === 'SUCURSAL' || roleTemp.role === 'MULTISUCURSAL') {
              this.fCleanClient();
            }

            if (roleTemp.role === this.dRoleSelect) {
              this.itemsOpciones = roleTemp.opciones
              this.itemsInformes = roleTemp.informes
              break;
            }
          }
          this.dSelectClient = { codigo: '', nombre: '' }
          this.dSelectRepre = { codigo: '', subfield: '', nombre: '' }
        } else {
          this.itemsOpciones = this.usuarioSeleccionadoIni.opciones
          this.itemsInformes = this.usuarioSeleccionadoIni.informes
          if (this.dUsuarioSeleccionado.role !== 'REPRESENTANTE' && this.dUsuarioSeleccionado.role !== 'ADMIN') {
            this.itemsInformes = this.itemsInformes.filter((item) => item.informe !== 'PRESUPUESTOS')
          }
          if (this.usuarioSeleccionadoIni.cliente !== '') {
            this.dSelectClient = { codigo: this.usuarioSeleccionadoIni.cliente, nombre: this.usuarioSeleccionadoIni.clienteNombre }
          } else {
            this.dSelectClient = { codigo: '', nombre: '' }
          }
          if ((this.usuarioSeleccionadoIni.representante !== '') && (this.usuarioSeleccionadoIni.representante !== null)) {
            this.dSelectRepre = { codigo: this.usuarioSeleccionadoIni.representante, subfield: this.dUsuarioSeleccionado.agente, nombre: this.usuarioSeleccionadoIni.representanteNombre }
          } else {
            this.dSelectRepre = { codigo: '', subfield: '', nombre: '' }
          }
        }
        this.checkChange()
      },
      deep: true
    },
    'dUsuarioSeleccionado.cliente': {
      handler: function () {
        this.checkChange()
      },
      deep: true
    },
    'dUsuarioSeleccionado.representante': {
      handler: function () {
        this.checkChange()
      },
      deep: true
    },
    paginationSUC: {
      handler() {
        if (this.dSelectClient.codigo !== undefined && this.dSelectClient.codigo !== '') {
          this.dUsuarioSeleccionado.sucursales = []
          this.cargaSucursales(this.paginationSUC.sortBy, this.paginationSUC.descending, this.paginationSUC.page, this.paginationSUC.rowsPerPage, this.searchSUC, [])
        }
      },
      deep: true
    }
  },
  computed: {
    cSearch() {
      return this.dSearch
    },
    // Configuración de campos sub dinámicos
    subFieldsConfig() {
      return {
        'ESTADO_PED_ALB': {
          fieldName: 'consultaDocEstadoPedSN',
          labelKey: 'consultaDocEstadoPed'
        }
      }
    },
    flatInformes() {
      const res = []
      if (this.itemsInformes) {
        this.itemsInformes.forEach((informe, index) => {
          res.push({ type: 'main', informe, originalIndex: index })
          const config = this.subFieldsConfig[informe.informe]
          if (config) {
            res.push({ 
              type: 'sub', 
              informe, 
              originalIndex: index,
              fieldName: config.fieldName,
              labelKey: config.labelKey
            })
          }
        })
      }
      return res
    }
  },
  created() {
    this.fIniciarVariables()
    // Inicializar opciones del filtro de estado
    this.itemsEstadoFiltro = [
      { text: this.$t('todos'), value: 'todos' },
      { text: this.$t('activos'), value: 'activos' },
      { text: this.$t('pasivos'), value: 'pasivos' }
    ]
    /*
     * Evento de carga de usuarios
     */
    this.$bus.$on(this.dEventosBus.cargaLista, (parametros, user) => {
      this.ultimosParametros = parametros
      // Sincronizar dSearch con el valor de búsqueda actual
      if (parametros.search !== undefined) {
        this.dSearch = parametros.search
      }
      this.cargaUsuarios(parametros.sortBy, parametros.descending, parametros.page, parametros.rowsPerPage, parametros.search, parametros.filters, user)
    })
    /*
     * Evento que abre un usuario
     */
    this.$bus.$on(this.dEventosBus.muestraDatos, (usuario) => {
      this.muestraDatosUsuario(usuario)
    })

    this.cargaEmpresas()

    // Carga los itemsRoles
    this.cargaRoles()
  },
  beforeDestroy() {
    /*
     * Evento de carga de usuarios
     */
    this.$bus.$off(this.dEventosBus.cargaLista)
    /*
     * Evento que abre un usuario
     */
    this.$bus.$off(this.dEventosBus.muestraDatos)
  },
  methods: {
    fText(item) {
      return item.empresa + ' - ' + item.nombre
    },
    fIniciarVariables() {
      this.dDataClient = {
        'errorMessages': [],
        'label': 'clienteInicial',
        'rowsPerPage': 5,
        'headers': [
          { text: this.$t('cliente'), align: 'left', value: 'codigo', column: 'cliente' },
          { text: this.$t('nombreCliente'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovClte',
        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'cliente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'request': this.dRequestClient,
        'default': this.dSelectClient,
        'disabled': false,
        'required': false,
        'orderByDefault': 'cliente',
        'orderDefault': 'ASC',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': 'seleccionaUnCliente'
      }
      this.dDataRepre = {
        'labelMainField': 'codigo',
        'labelSubField': 'agente',
        'label': 'representanteInicial',
        'rowsPerPage': 5,
        'headers': [
          { text: this.$t('Representante'), align: 'left', value: 'codigo', column: 'representante' },
          { text: this.$t('agente'), align: 'left', value: 'subfield', column: 'agente' },
          { text: this.$t('nombreRepresentante'), align: 'left', value: 'nombre', column: 'nombre' }
        ],
        'urlWS': 'lovRep',
        'item': { 'codigo': '', 'subfield': '', 'nombre': '' },
        'request': this.dRequestRepre,
        'filters': { 'codigo': 'representante', 'subfield': 'agente', 'nombre': 'nombre' },
        'resultName': 'dataRes',
        'default': this.dSelectRepre,
        'disabled': false,
        'required': false,
        'title': 'selectRepresentante',
        'isVisibleLoad': true,
        'orderByDefault': 'representante',
        'orderDefault': 'ASC'
      }
      this.dDataSucursal = {
        'errorMessages': [],
        'label': this.$t('sucursal'),
        'rowsPerPage': 10,
        'headers': [
          { text: this.$t('sucursal'), align: 'left', value: 'codigo', column: 'sucursal' },
          { text: this.$t('nombreSucursal'), align: 'left', value: 'nombre', column: 'razonSocial' }
        ],
        'urlWS': 'lovDic',

        'item': { 'codigo': '', 'nombre': '' },
        'filters': { 'codigo': 'sucursal', 'nombre': 'razonSocial' },
        'resultName': 'dataRes',
        'request': null,
        'default': this.dSelectSucursal,
        'disabled': true,
        'required': true,
        'orderByDefault': 'sucursal',
        'orderDefault': 'sucursal',
        'isVisibleLoad': true,
        'textCodigo': 'codigo',
        'title': this.$t('seleccionaUnaSucursal'),
        'client': this.dSelectClient.codigo
      }
    },
    fSelectRepre(item) {
      if (item && item != null) {
        this.dSelectRepre.codigo = item.codigo
        this.dSelectRepre.subfield = item.subfield
        this.dSelectRepre.nombre = item.nombre
      }
    },
    fCleanRepre() {
      this.dSelectRepre = {}
      this.dUsuarioSeleccionado.representante = ''
      this.dUsuarioSeleccionado.agente = ''
    },
    fSelectClient(item) {
      if (item && item != null) {
        this.dSelectClient.codigo = item.codigo
        this.dSelectClient.nombre = item.nombre
      }
      if ((this.dRoleSelect === "SUCURSAL" || this.dRoleSelect === "MULTISUCURSAL") && this.dSelectClient.codigo === undefined) {
        this.fCleanClient()
      }

      this.dDataSucursal.client = item.codigo
      this.dDataSucursal.request = {
        empresa: this.dUsuarioSeleccionado.empresa,
        cliente: item.codigo
      }

      if (item.codigo !== '' && item.codigo !== undefined && this.$refs.RefTablaSucursal !== undefined) {

        this.$refs.RefTablaSucursal.fChangeDisabled(false)
      }
    },
    fCleanClient() {
      if (this.$refs.RefTablaSucursal !== undefined) {

        this.$refs.RefTablaSucursal.fChangeDisabled(true)
        this.$refs.RefTablaSucursal.fClear()
      }
      if (this.$refs.RefTablaClient !== undefined) {
        this.$refs.RefTablaClient.fClean()
      }
      this.fClearSucursal()
      this.dSelectCliente = {}
    },
    fSelectSucursal(item) {
      this.dSelectSucursal.codigo = item.codigo
      this.dSelectSucursal.nombre = item.nombre
    },
    fClearSucursal() {
      this.dDataSucursal.disabled = true
      this.dSelectSucursal = {}
    },
    changeValue(index) {
      this.checkChange()
    },
    cargaSucursales(sortBy = 'sucursal', descending = false, page = 1, rowsPerPage = this.paginationSUC.rowsPerPage, search = '', filters = []) {
      this.loadingSUC = true;
      this.filters = filters;
      const offset = rowsPerPage * (page - 1) + 1;
      const order = descending ? 'DESC' : 'ASC';

      const jsonEntrada = {
        tira: this.$store.getters.getAutenticacion.tira,
        usuario: this.$store.getters.getAutenticacion.usuario,
        empresa: this.$store.getters.getAutenticacion.empresa,
        cliente: this.dSelectClient.codigo,
        searchCols: 'sucursal,razonSocial',
        offset,
        numRows: rowsPerPage,
        orderBy: sortBy,
        order,
        filters
      };

      if (this.dIsOnPremise) {
        jsonEntrada.search = search;
      } else {
        const formattedSearch = search ? `%${search}%` : '%%%';
        jsonEntrada.searchClienteIdentFiscalNombreRazonSocial = formattedSearch;
        jsonEntrada.searchClienteRazonSocialTelefonoEmail = formattedSearch;
      }

      SrvGeneral.lovDic(jsonEntrada).then(({ data }) => {
        this.sucursales = data.numReg > 0 ? data.dataRes : [];

        this.sucursales.forEach(sucursal => {
          sucursal.selected = this.selectedSUC.some(sel => sel.sucursal === sucursal.sucursal);
        });

        if (this.dSelectClient.codigo === this.dUsuarioSeleccionado.cliente) {
          this.dUsuarioSeleccionado.sucursales.forEach(item => {
            const yaSeleccionada = this.selectedSUC.some(suc => suc.sucursal === item.sucursal);
            if (!yaSeleccionada) {
              const sucursalFinal = this.sucursales.find(suc => suc.sucursal === item.sucursal);
              if (sucursalFinal) {
                this.selectedSUC.push(sucursalFinal);
              }
            }
          });
        }

        this.totalItemsSUC = data.numReg;
        this.dSelectAllElements = this.sucursales.length === this.selectedSUC.length;
        this.loadingSUC = false;
        this.numValidacionesValue = 0;
        this.buscarTxt = this.$t('buscar');
      }).catch(error => {
        const res = error.response.data;
        const errorPortal = res.statusText || res.exception || res.errorMsg || 'Error desconocido';
        console.error('Error:', error);
        this.$emit('alert', '<b>carga pedidos</b><br> ' + errorPortal);
      });
    },
    /**
     * Busca sucursales por el buscador
     */
    fSearchSucursal() {
      clearInterval(this.dSearchCustTime)
      this.dSearchSucTime = setTimeout(function () {
        this.dUsuarioSeleccionado.sucursales = []
        this.cargaSucursales(this.paginationSUC.sortBy, this.paginationSUC.descending, this.paginationSUC.page, this.paginationSUC.rowsPerPage, this.searchSUC, [])
      }.bind(this), 800)
    },
    /**
     * selecciona y deselecciona un elemento
     */
    fChangeSelectedItem(props) {
      if (props.selected) {
        const index = this.selectedSUC.findIndex(item => item.id === props.item.id)
        if (index !== -1) {
          this.selectedSUC.splice(index, 1)
        }
      } else {
        this.selectedSUC.push(props.item)
      }
    },
    toggleAll() {
      if (!this.dSelectAllElements) {
        this.unSelectAll()
      } else {
        this.selectAll()
      }
    },
    /**
     * Borra un elemento de la lista de elementos
     */
    fDeleteClientSelect(cliente, index) {
      cliente.selected = false
      this.selectedSUC.splice(index, 1)
      this.updateSelectAll()
    },
    /**
     * Borra un elemento de la lista de elementos
     */
    updateSelectAll() {
      let allUnselected = true
      for (let j = 0; j < this.sucursales.length; j++) {
        const itemTemp2 = this.sucursales[j]
        if (itemTemp2.selected) {
          allUnselected = false
          break
        }
      }
      if (allUnselected) {
        this.dSelectAllElements = false
      }
    },
    /**
     * Borra un elemento de la lista de elementos
     */
    selectAll() {
      this.sucursales.forEach(sucursal => {
        const existeCliente = this.selectedSUC.some(sel => sel.cliente === sucursal.cliente);
        if (!existeCliente) {
          sucursal.selected = true;
          this.selectedSUC.push(sucursal);
        }
      });
    },
    /**
     * Borra un elemento de la lista de elementos
     */
    unSelectAll() {
      const indicesToDelete = [];

      this.sucursales.forEach(sucursal => {
        const index = this.selectedSUC.findIndex(sel => sel.cliente === sucursal.cliente);
        if (index !== -1) {
          sucursal.selected = false;
          indicesToDelete.push(index);
        }
      });

      indicesToDelete.sort((a, b) => b - a).forEach(index => {
        this.selectedSUC.splice(index, 1);
      });
    },
    /*
     * cambia el orden de an columna
     */
    cambiaOrden(column) {
      this.paginationSUC.page = 1
      this.paginationSUC.rowsPerPage = 8
      if (this.paginationSUC.sortBy === column) {
        this.paginationSUC.descending = !this.paginationSUC.descending
      } else {
        this.paginationSUC.sortBy = column
        this.paginationSUC.descending = false
      }
    },
    /*
     * Metodo de carga de usuarios
     */
    cargaUsuarios(sortBy, descending, page, rowsPerPage, search, filters, user) {
      this.loading = true
      this.filters = filters

      let offset = 1

      descending = (descending) ? 'DESC' : 'ASC'
      page = (page === undefined) ? 1 : page
      rowsPerPage = (rowsPerPage === undefined) ? this.pagination.rowsPerPage : rowsPerPage
      filters = (filters === undefined) ? [] : filters

      // Agregar filtro de estado si no es "todos"
      if (this.dEstadoFiltro !== 'todos') {
        const estadoFiltro = this.dEstadoFiltro === 'activos' ? 'S' : 'N'
        // Remover cualquier filtro de estado existente (puede ser objeto o array)
        filters = filters.filter(f => {
          if (Array.isArray(f)) {
            return f[0] !== 'activoSN'
          } else if (typeof f === 'object' && f !== null) {
            return f.property !== 'activoSN'
          }
          return true
        })
        // Agregar el nuevo filtro de estado en el formato correcto
        filters.push({
          property: 'activoSN',
          typeFilter: 'value',
          typeField: 'varchar',
          value: estadoFiltro
        })
      } else {
        // Si es "todos", remover el filtro de estado si existe
        filters = filters.filter(f => {
          if (Array.isArray(f)) {
            return f[0] !== 'activoSN'
          } else if (typeof f === 'object' && f !== null) {
            return f.property !== 'activoSN'
          }
          return true
        })
      }

      if (sortBy === undefined) {
        sortBy = 'usuario'
        descending = 'ASC'
      }
      offset = this.pagination.rowsPerPage * (page - 1) + 1

      // revisar la carga de datos y las columnas
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion,
        search: search,
        offset: offset,
        numRows: rowsPerPage,
        orderBy: sortBy,
        order: descending,
        filters: filters
      }
      SrvUsers.getUsersInformes(payload).then(response => {
        if (response.data.statusCode === '200') {
          const itemsTemp = response.data.result
          itemsTemp.map((item, index) => {
            item.selected = false
            item.opciones.map((opcion, index1) => {
              opcion.value = false
              opcion.nombreTxt = this.$t(opcion.nombre)
              opcion.value = (opcion.valueSN === 'S')
            })
            item.informes.map((informe, index1) => {
              informe.value = false
              informe.descripcionTxt = this.$t(informe.descripcion)
              informe.value = (informe.valueSN === 'S')
            })
          })
          this.totalItems = response.data.totalRows
          this.items = itemsTemp
          // El primer usuario será el usuario seleccionado
          if (this.totalItems > 0) {
            if (user) {
              this.muestraDatosUsuario(user)
            } else {
              this.muestraDatosUsuario(this.items[0])
            }
          } else {
            // Limpiar todos los bloques cuando no hay resultados
            this.dUsuarioSeleccionado = { usuario: '', nombre: '', email: '', telefono: '', empresa: '', role: '', cliente: '', representante: '', agente: '', opciones: [], informes: [] }
            this.selectEmpresa = ''
            this.selectRole = ''
            this.itemsOpciones = []
            this.itemsInformes = []
            this.dSelectClient = { codigo: '', nombre: '' }
            this.dSelectRepre = { codigo: '', subfield: '', nombre: '' }
            this.dSelectSucursal = { codigo: '', nombre: '' }
            this.selectedSUC = []
            this.dSucursales = []
            this.disabledUpdate = true
            this.change = false
            this.puedeActivarUsuario = false
            // Limpiar referencias de componentes si existen
            if (this.$refs.RefTablaClient) {
              this.$refs.RefTablaClient.fClean()
            }
            if (this.$refs.RefTablaRepre) {
              this.$refs.RefTablaRepre.fClean()
            }
            if (this.$refs.RefTablaSucursal) {
              this.$refs.RefTablaSucursal.fClear()
            }
          }


          this.loading = false
        } else {
          this.fErrorComprobado(response)
          this.loading = false
        }
      }).catch(error => {
        if (error.response !== null) {
          this.fErrorComprobado(error.response)
        }
        this.loading = false
      })
    },
    /*
     * Metodo de acutalizacion del usuario seleccionado
     */
    actualizaUsuario() {
      this.dUsuarioSeleccionado.cliente = this.dSelectClient.codigo
      this.dUsuarioSeleccionado.clienteNombre = this.dSelectClient.nombre

      this.dUsuarioSeleccionado.representante = this.dSelectRepre.codigo
      this.dUsuarioSeleccionado.agente = this.dSelectRepre.subfield
      this.dUsuarioSeleccionado.representanteNombre = this.dSelectRepre.nombre

      this.dUsuarioSeleccionado.role = this.dRoleSelect

      this.dUsuarioSeleccionado.opciones.map((opcion, index) => {
        opcion.valueSN = (opcion.value) ? 'S' : 'N'
      })
      this.dUsuarioSeleccionado.informes.map((informe, index) => {
        informe.valueSN = (informe.value) ? 'S' : 'N'
      })
      // Convertir campos sub dinámicos de booleano a "S"/"N" para enviarlos al backend
      const subFieldsValues = {}
      Object.keys(this.subFieldsConfig).forEach(informeKey => {
        const config = this.subFieldsConfig[informeKey]
        const fieldName = config.fieldName
        const value = this.dUsuarioSeleccionado[fieldName]
        subFieldsValues[fieldName] = (value === true || value === 'S') ? 'S' : 'N'
      })
      const nombreEmpresa = this.getNombreEmpresa(this.selectEmpresa)

      // revisar la carga de datos y las columnas
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion,
        usuario: this.dUsuarioSeleccionado.usuario,
        ...subFieldsValues,
        usuarioModificacion: this.$store.getters.getAutenticacion.usuario,
        activoSN: 'S',
        nuevaEmpresa: this.selectEmpresa,
        nombreEmpresa: nombreEmpresa,
        role: this.dRoleSelect,
        opciones: this.dUsuarioSeleccionado.opciones,
        informes: this.dUsuarioSeleccionado.informes
      }
      // 
      switch (this.dRoleSelect) {
        case 'REPRESENTANTE':
          payload.representante = this.dUsuarioSeleccionado.representante
          payload.agente = this.dUsuarioSeleccionado.agente
          break
        case 'CLIENTE':
          payload.cliente = this.dUsuarioSeleccionado.cliente
          break
        case 'SUCURSAL':
          payload.cliente = this.dSelectClient.codigo
          payload.sucursal = this.dSelectSucursal.codigo
          break
        case 'MULTISUCURSAL':
          payload.cliente = this.dSelectClient.codigo
          payload.sucursales = this.dSucursales
          payload.sucursal = this.dSucursales[0]
          break
        default:
      }
      SrvUsers.actualizaUsuario(payload).then(response => {
        if (response.data.statusCode === '200') {
          if (Object.keys(response.data.errorMsg).length === 0 && Object.keys(response.data.infoMsg).length > 0) {
            
            this.$refs.DataTableUser.fRecargar(this.ultimosParametros, this.dUsuarioSeleccionado)
            if (this.usuarioPendiente !== null) {
              this.items.forEach(usuario => {
                this.fCheckUserDetails(usuario)
              })
              this.usuarioPendiente = null
            }
            this.$bus.$emit(this.dEventosBus.mostrarAviso, this.$t('usuarioActualizado'))
          } else {
            if (response.data.errorMsg.message) {
              this.$bus.$emit(this.dEventosBus.mostrarAviso, this.$t('errorInsertUser') + '<br/>' + response.data.errorMsg.message)
            } else {
              this.$bus.$emit(this.dEventosBus.mostrarAviso, this.$t('errorInsertUser') + '<br/>' + response.data.errorMsg)
            }
          }
        } else {
          this.fErrorComprobado(response)
        }
      }).catch(error => {
        this.fErrorComprobado(error.response)
      })
    },
    fEliminarUsuario() {
      this.dUsuarioSeleccionado.cliente = this.dSelectClient.codigo
      this.dUsuarioSeleccionado.clienteNombre = this.dSelectClient.nombre

      this.dUsuarioSeleccionado.representante = this.dSelectRepre.codigo
      this.dUsuarioSeleccionado.agente = this.dSelectRepre.subfield
      this.dUsuarioSeleccionado.representanteNombre = this.dSelectRepre.nombre

      this.dUsuarioSeleccionado.opciones.map((opcion, index) => {
        opcion.valueSN = (opcion.value) ? 'S' : 'N'
      })
      this.dUsuarioSeleccionado.informes.map((informe, index) => {
        informe.valueSN = (informe.value) ? 'S' : 'N'
      })

      // revisar la carga de datos y las columnas
      const parametrosUsuarios = {
        tira: this.$store.getters.getAutenticacion.tira,
        organizacion: this.$store.getters.getAutenticacion.organizacion,
        usuario: this.dUsuarioSeleccionado.usuario,
        empresa: this.dUsuarioSeleccionado.empresa,
      }
      SrvAdmUsuarios.deleteUsers(parametrosUsuarios).then(response => {
        if (response.data.statusCode === '200') {
          if (Object.keys(response.data.errorMsg).length === 0 && Object.keys(response.data.infoMsg).length > 0) {
            this.$refs.DataTableUser.fRecargar(this.ultimosParametros)
            this.$bus.$emit(this.dEventosBus.mostrarAviso, this.$t('usuarioEliminado'))
          } else {
            if (response.data.errorMsg.message) {
              this.$bus.$emit(this.dEventosBus.mostrarAviso, this.$t('errorDeleteUser') + '<br/>' + response.data.errorMsg.message)
            } else {
              this.$bus.$emit(this.dEventosBus.mostrarAviso, this.$t('errorDeleteUser') + '<br/>' + response.data.errorMsg)
            }
          }
        } else {
          this.fErrorComprobado(response)
        }
      }).catch(error => {
        this.fErrorComprobado(error.response)
      })

    },
    /*
     * muestra los datos de un usuario
     */
    fCheckUserDetails(usuario) {
      if (usuario.login === this.usuarioPendiente.login) {
        this.change = false
        this.muestraDatosUsuario(usuario)
        return true
      } else {
        return false
      }
    },
    fCheckUser(usuario) {
      if (usuario.login === this.dUsuarioSeleccionado.login) {
        this.copiaUsuario(this.dUsuarioSeleccionado, usuario)
        return true
      } else {
        return false
      }
    },
    muestraDatosUsuario(usuario) {
      if (this.change) {
        this.alertaGuardadoPendiente = true;
        this.usuarioPendiente = { ...usuario };
        return;
      }

      this.cargandoUsuario = true;
      this.alertaGuardadoPendiente = false;
      this.usuarioPendiente = null;
      this.disabledUpdate = true;
      this.change = false;
      this.puedeActivarUsuario = false;

      const reset = {
        selectEmpresa: '',
        selectRole: '',
        itemsOpciones: [],
        itemsInformes: [],
        dSelectClient: { codigo: '', nombre: '' },
        dSelectRepre: { codigo: '', subfield: '', nombre: '' },
        dSelectSucursal: { codigo: '', nombre: '' }
      };

      Object.assign(this, reset);
      Object.assign(this.dUsuarioSeleccionado, usuario);
      // Convertir campos sub dinámicos de "S"/"N" a booleano para los checkboxes
      Object.keys(this.subFieldsConfig).forEach(informeKey => {
        const config = this.subFieldsConfig[informeKey]
        const fieldName = config.fieldName
        if (this.dUsuarioSeleccionado[fieldName] !== undefined) {
          this.dUsuarioSeleccionado[fieldName] = (this.dUsuarioSeleccionado[fieldName] === 'S' || this.dUsuarioSeleccionado[fieldName] === true);
        } else {
          this.dUsuarioSeleccionado[fieldName] = false;
        }
      })
      this.selectEmpresa = usuario.empresa;
      this.selectRole = usuario.role;
      this.itemsOpciones = [...usuario.opciones];
      this.itemsInformes = [...usuario.informes];

      const setTimeoutActualizar = (ref, item) => {
        setTimeout(() => {
          if (this.$refs[ref]) {
            this.$refs[ref].fActualizarItem(item);
          }
        }, 200);
      };

      switch (usuario.role) {
        case 'CLIENTE':
          this.dSelectClient = { codigo: usuario.cliente, nombre: usuario.clienteNombre };
          setTimeoutActualizar('RefTablaClient', this.dSelectClient);
          break;
        case 'REPRESENTANTE':
          this.dSelectRepre = {
            codigo: usuario.representante,
            subfield: usuario.agente,
            nombre: usuario.representanteNombre
          };
          setTimeoutActualizar('RefTablaRepre', this.dSelectRepre);
          break;
        case 'SUCURSAL':
          this.dSelectClient = { codigo: usuario.cliente, nombre: usuario.clienteNombre };
          this.dSelectSucursal = { codigo: usuario.sucursal, nombre: usuario.sucursalNombre };
          setTimeout(() => {
            if (this.$refs.RefTablaClient) {
              this.$refs.RefTablaClient.fActualizarItem(this.dSelectClient);
            }
            if (this.$refs.RefTablaSucursal && this.dSelectClient.codigo) {
              this.$refs.RefTablaSucursal.fChangeDisabled(false);
              this.$refs.RefTablaSucursal.fActualizarItem(this.dSelectSucursal);
            }
          }, 200);
          break;
        case 'MULTISUCURSAL':
          this.dSelectClient = { codigo: usuario.cliente, nombre: usuario.clienteNombre };
          break;
        case 'ADMIN':
          this.puedeActivarUsuario = true;
          break;
      }

      if (!this.puedeActivarUsuario) {
        const { role, representante, cliente, sucursal } = this.dUsuarioSeleccionado;
        this.puedeActivarUsuario =
          (role === 'REPRESENTANTE' && representante) ||
          (role === 'CLIENTE' && cliente) ||
          (role === 'SUCURSAL' && cliente && sucursal);
      }

      this.copiaUsuario(this.dUsuarioSeleccionado, this.usuarioSeleccionadoIni);
    },
    /*
     * Evento para lanzar la carga de datos
     */
    cargaEmpresas() {
      const sortBy = 'nombre'
      const descending = 'ASC'
      // prepara los parametros generales de busqueda
      const jsonEntrada = {
        tira: this.$store.getters.getAutenticacion.tira,
        orderBy: sortBy,
        order: descending
      }
      SrvGeneral.lovEmpresa(jsonEntrada).then(response => {
        if (response.data.statusCode === '200') {
          this.itemsEmpresas = response.data.dataRes
        } else {
          this.$bus.$emit(this.dEventosBus.mostrarAviso, this.$t('errorDefault') + '<br>' + response.data.statusText + '  (' + response.data.statusCode + ' ) ')
        }
      }).catch(error => {
        this.$bus.$emit(this.dEventosBus.mostrarAviso, this.$t('errorDefault') + '<br>' + error.response.data.statusText)
      })
    },
    /*
     * Obtiene el nombre de una empresa
     */
    getNombreEmpresa(empresa) {
      const empresaEncontrada = this.itemsEmpresas.find(e => e.empresa === empresa);
      return empresaEncontrada ? empresaEncontrada.nombre : '';
    },
    /*
     * Evento para lanzar la carga de datos
     */
    cargaRoles() {
      // prepara los parametros generales de busqueda
      const payload = {
        tira: this.$store.getters.getAutenticacion.tira,
        idOrganizacion: this.$store.getters.getAutenticacion.organizacion
      }
      SrvFechasRoles.getRoles(payload).then(response => {
        if (response.data.statusCode === '200') {
          const datosRoles = response.data
          this.itemsRoles = datosRoles.result
          if (this.dIsOnPremise === 'yes') {
            this.itemsRoles.pop()
          }

          this.itemsRoles.map((role, index) => {
            role.descripcionTexto = this.$t(role.descripcion)
            role.opciones.map((opcion, index) => {
              opcion.value = false
              opcion.nombreTxt = this.$t(opcion.nombre)
              opcion.value = (opcion.valueSN === 'S')
            })
            role.informes.map((informe, index) => {
              informe.value = false
              informe.descripcionTxt = this.$t(informe.descripcion)
              informe.value = (informe.valueSN === 'S')
            })
          })
        } else {
          if (response) {
            this.fErrorComprobado(response)
          }
        }
      }).catch(error => {
        if (error.response !== undefined) {
          this.fErrorComprobado(error.response)
        }
      })
    },
    /*
     * Maneja el cambio del filtro de estado
     */
    fCambiarEstadoFiltro() {
      if (this.$refs.DataTableUser) {
        const parametros = this.ultimosParametros || {
          sortBy: this.sortBy,
          descending: this.descending,
          page: 1,
          rowsPerPage: this.pagination.rowsPerPage,
          search: this.dSearch || '',
          filters: []
        }
        // Asegurar que el valor de búsqueda esté actualizado
        if (parametros.search === undefined || parametros.search === '') {
          parametros.search = this.dSearch || ''
        }
        
        this.$refs.DataTableUser.fRecargar(parametros, this.dUsuarioSeleccionado)
      }
    },
    /*
     * Evento para lanzar la carga de datos
     */
    checkChange() {

      if (this.itemsOpciones.length > 0) {
        this.dUsuarioSeleccionado.opciones = this.itemsOpciones
      }
      if (this.itemsInformes.length > 0) {
        this.dUsuarioSeleccionado.informes = this.itemsInformes
      }
      this.disabledUpdate = true
      this.change = false
      this.puedeActivarUsuario = false
      if (this.dUsuarioSeleccionado.role === 'ADMIN') {
        this.puedeActivarUsuario = true
      } else {
        if ((this.dUsuarioSeleccionado.role === 'REPRESENTANTE') && (this.dUsuarioSeleccionado.representante !== '')) {
          this.puedeActivarUsuario = true
        } else {
          if ((this.dUsuarioSeleccionado.role === 'CLIENTE') && (this.dUsuarioSeleccionado.cliente !== '')) {
            this.puedeActivarUsuario = true
          }
          if ((this.dUsuarioSeleccionado.role === 'SUCURSAL') && (this.dUsuarioSeleccionado.sucursal !== '')) {
            this.puedeActivarUsuario = true
          }
        }
      }
    },
    /*
     * Evento para lanzar la carga de datos
     */
    cierraAlertaGuardadoPendiente() {
      this.fRestauraUsuario()
      this.change = false
      this.muestraDatosUsuario(this.usuarioPendiente)
      this.alertaGuardadoPendiente = false
    },
    /*
     * Evento para lanzar la carga de datos
    */
    cierraAlertaGuardando() {
      this.actualizaUsuario()
      this.change = false
      this.alertaGuardadoPendiente = false
    },
    /*
     * restaura un usuario que no se quiere cambiar
    */
    fRestauraUsuario() {
      for (let i = 0; i < this.items.length; i++) {
        const usuario = this.items[i]
        if (usuario.login === this.usuarioSeleccionadoIni.login) {
          this.copiaUsuario(this.usuarioSeleccionadoIni, usuario)
          break
        }
      }
    },
    /*
     * Evento para lanzar la carga de datos
    */
    copiaUsuario(usuarioOri, usuarioDst) {
      usuarioDst.usuario = usuarioOri.usuario
      usuarioDst.login = usuarioOri.login
      usuarioDst.nombre = usuarioOri.nombre
      usuarioDst.telefono = usuarioOri.telefono
      usuarioDst.email = usuarioOri.email
      usuarioDst.fechaAlta = usuarioOri.fechaAlta
      usuarioDst.empresa = usuarioOri.empresa
      usuarioDst.nombreEmpresa = usuarioOri.nombreEmpresa
      usuarioDst.role = usuarioOri.role
      usuarioDst.cliente = usuarioOri.cliente
      usuarioDst.clienteNombre = usuarioOri.clienteNombre
      usuarioDst.sucursal = usuarioOri.sucursal
      usuarioDst.sucursalNombre = usuarioOri.sucursalNombre
      usuarioDst.representante = usuarioOri.representante
      usuarioDst.agente = usuarioOri.agente
      usuarioDst.representanteNombre = usuarioOri.representanteNombre

      let existenOpcionesDst = true
      usuarioDst.opciones = []
      if (usuarioDst.opciones === null || usuarioDst.opciones === undefined || usuarioDst.opciones.length === 0) {
        existenOpcionesDst = false
      }
      for (let i = 0; i < usuarioOri.opciones.length; i++) {
        if (existenOpcionesDst) {
          usuarioDst.opciones[i].id = usuarioOri.opciones[i].id
          usuarioDst.opciones[i].padre = usuarioOri.opciones[i].padre
          usuarioDst.opciones[i].nombre = usuarioOri.opciones[i].nombre
          usuarioDst.opciones[i].nombreTxt = usuarioOri.opciones[i].nombreTxt
          usuarioDst.opciones[i].orden = usuarioOri.opciones[i].orden
          usuarioDst.opciones[i].valueSN = usuarioOri.opciones[i].valueSN
          usuarioDst.opciones[i].value = usuarioOri.opciones[i].value
        } else {
          const opcion = {
            id: usuarioOri.opciones[i].id,
            padre: usuarioOri.opciones[i].padre,
            nombre: usuarioOri.opciones[i].nombre,
            nombreTxt: usuarioOri.opciones[i].nombreTxt,
            orden: usuarioOri.opciones[i].orden,
            valueSN: usuarioOri.opciones[i].valueSN,
            value: usuarioOri.opciones[i].value
          }
          usuarioDst.opciones.push(opcion)
        }
      }

      let existenInformesDst = true
      usuarioDst.informes = []

      if (usuarioDst.informes === null || usuarioDst.informes === undefined || usuarioDst.informes.length === 0) {
        existenInformesDst = false
      }

      for (let i = 0; i < usuarioOri.informes.length; i++) {
        if (existenInformesDst) {
          usuarioDst.informes[i].informe = usuarioOri.informes[i].informe
          usuarioDst.informes[i].descripcion = usuarioOri.informes[i].descripcion
          usuarioDst.informes[i].descripcionTxt = usuarioOri.informes[i].descripcionTxt
          usuarioDst.informes[i].valueSN = usuarioOri.informes[i].valueSN
          usuarioDst.informes[i].value = usuarioOri.informes[i].value
        } else {
          const informe = {
            informe: usuarioOri.informes[i].informe,
            descripcion: usuarioOri.informes[i].descripcion,
            descripcionTxt: usuarioOri.informes[i].descripcionTxt,
            valueSN: usuarioOri.informes[i].valueSN,
            value: usuarioOri.informes[i].value
          }
          usuarioDst.informes.push(informe)
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Administracion/ShpAdministracionUsuarios.vue